import en from 'date-fns/locale/en-US';
import { LangValueType } from 'core/types';
import CORE_SETTINGS from 'core/settings';
import { KEY_AUTH_TOKEN } from 'const';

CORE_SETTINGS.defaultLanguage = LangValueType.en;
CORE_SETTINGS.excludeLanguage = LangValueType.en;
CORE_SETTINGS.displayedLanguages = [LangValueType.en];
CORE_SETTINGS.localeLanguages = { [LangValueType.en]: en };
CORE_SETTINGS.authTokenStorage = KEY_AUTH_TOKEN;
CORE_SETTINGS.nameApiHeaderToken = 'X-AUTH-TOKEN';
CORE_SETTINGS.gtmId = 'GTM-N9HPSNK';

export default CORE_SETTINGS;
